import "./style.scss";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// Imports from MUI
import { Menu, MenuItem } from "@mui/material";
// Imports from React
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface InputProps {
    cursorPosition?: number;
    field: string;
    variables: Record<string, string>;
    // description: Record<string, string>;
    onSelect: (value: string) => void;
}

const InsertVariable = ({ cursorPosition, field, variables, onSelect }: InputProps) => {
    const [t] = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (value: string) => {
        // if (value === "backdropClick") {
        //     return
        // }
        setAnchorEl(null);

        const newValue = field.slice(0, cursorPosition) + value + field.slice(cursorPosition);
        onSelect(newValue);
    };

    return (
        <>
            <button className="insert-btn" onClick={handleClick}>
                <div className="btn-text">{t("Accounting.InsertVariable")}</div>
                <div className="btn-arrow">
                    <ExpandMoreIcon></ExpandMoreIcon>
                </div>
            </button>
            <Menu
                id="menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                className="insert-variable-menu"
                elevation={0}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                {Object.entries(variables).map(([key, value]) => {
                    // const legend = Object.keys(description).find(key => key === value)
                    return (
                        <MenuItem
                            key={key}
                            onClick={() => handleClose(key)}
                            sx={{
                                fontSize: "13px",
                                fontFamily: "Poppins",
                                borderBottom: "1px solid rgb(234, 234, 234)",
                            }}
                        >
                            {key}
                            {value}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

export default InsertVariable;
